import ApplicationReports from "./ApplicationReports";

const RejectsApplications = () => {
  return(
    <ApplicationReports status="5" title="Rejected Applications Report" heading="Rejected Applications"></ApplicationReports>
  )
};

export default RejectsApplications;
